import { type RefSelectProps } from 'antd'
import clsx from 'clsx'
import { type Ref, forwardRef } from 'react'

import { Select } from '@/components/elements'
import { type SingleOrMultipleSelectProps } from '@/components/types'
import { DESCRIPTIONS } from '@/constants/common/message.constants'
import { type AdditionalPaymentCategoryEntity } from '@/libs/api'
import type { ReportType } from '@/libs/api/types'
import { useSelectOnChangeHandler } from '@/libs/hooks'

import { useAdditionalPaymentCategoriesSelectQuery } from '../../hooks'

type Props = SingleOrMultipleSelectProps<
  number,
  AdditionalPaymentCategoryEntity
> & {
  tenantKey: string
  reportType: ReportType
  unselectedAdditionalPaymentCategories?: AdditionalPaymentCategoryEntity[]
}

/**
 * 追加支払種別を選択するSelectのベースComponent
 */
export const AdditionalPaymentCategoriesSelect = forwardRef(
  (
    {
      className,
      tenantKey,
      reportType,
      unselectedAdditionalPaymentCategories,
      value,
      placeholder = DESCRIPTIONS.SELECT,
      mode,
      onChange,
      ...props
    }: Props,
    ref: Ref<RefSelectProps> | undefined
  ) => {
    const { data, isFetching, isLoading } =
      useAdditionalPaymentCategoriesSelectQuery(tenantKey, reportType)
    const handleChange = useSelectOnChangeHandler({
      mode,
      onChange
    })

    return (
      <Select
        customRef={ref}
        mode={mode}
        value={isLoading ? null : value}
        placeholder={placeholder}
        fieldNames={{ label: 'name', value: 'id' }}
        optionFilterProp="name"
        className={clsx(['min-w-[160px]', className])}
        options={unselectedAdditionalPaymentCategories ?? data}
        loading={isFetching}
        onChange={handleChange}
        {...props}
      />
    )
  }
)
